module.exports = __webpack_public_path__ + "img/pandian.e8c84755.png";